var objectToString = Object.prototype.toString

module.exports = objectToString



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticObjectToString.js
// module id = 338
// module chunks = 98